import { captureEvent } from '@sentry/browser';


export const formatApiErrors = (response, defaultError = null) => {
  const errors: Array<string> = [];

  if (response.error) {
    if (response.error.errors) {
      const errObject: Array<Array<string>> | Array<string> = response.error.errors;

      for (const key of Object.keys(errObject)) {
        let validationErrors = errObject[key];

        if (typeof validationErrors === 'string') {
          validationErrors = [validationErrors];
        }

        validationErrors.forEach((err: string) => {
          const cleanedString = err.replace(/\b[A-z_]+\.([A-z]+)/, '$1');

          errors.push(cleanedString.charAt(0).toUpperCase() + cleanedString.slice(1));
        });
      }
    } else if (response.error.exception) {
      const errorMessage = defaultError ? defaultError : 'Unknown server error occured.';
      errors.push(errorMessage);
      captureEvent({
        'message': errorMessage,
        // 'errorMessage': response.error.message,
        // 'stacktrace': response.error.trace,
        // 'file': response.error.file,
        // 'line': response.error.line
      });
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/app/shared/utils/api.utils.ts